import { render } from "./EmailTable.vue?vue&type=template&id=bb0eeaf6"
import script from "./EmailTable.vue?vue&type=script&lang=js"
export * from "./EmailTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__